import React from "react";
import { Route, Routes } from "react-router-dom";

// screens
import MainScreen from "../Views/Root/MainScreen";
import NotFound404 from "../Views/Common/not-found-404";
import DashboardScreen from "../Views/Dashboard/DashboardScreen";
import VisitsScreen from "../Views/Visits/VisitsScreen";
import SchemesScreen from "../Views/Schemes/SchemesScreen";
import OfficesScreen from "../Views/Offices/OfficesScreen";
import UsersScreen from "../Views/Users/UsersScreen";
import FeedbackQuestionsScreen from "../Views/FeedbackQuestions/FeedbackQuestionsScreen";
import OfficeDetailsScreen from '../Views/Offices/OfficeDetailsScreen'
import SchemeDetailsScreen from "../Views/Schemes/SchemeDetailsScreen";
import VisitDetailsScreen from "../Views/Visits/VisitDetailsScreen";

function MainScreenNavigator(props) {
  return (
    <MainScreen {...props}>
      <Routes>
        <Route path="/" element={<DashboardScreen />} />
        <Route path="/dashboard" element={<DashboardScreen />} />
        <Route path="/visits" element={<VisitsScreen />} />
        <Route path="/schemes" element={<SchemesScreen />} />
        <Route path="/offices" element={<OfficesScreen />} />
        <Route path="/users" element={<UsersScreen />} />
        <Route path="/feedback-questions" element={<FeedbackQuestionsScreen />} />

        <Route path="/office/:officeId" element={<OfficeDetailsScreen />} />
        <Route path="/scheme/:schemeId" element={<SchemeDetailsScreen />} />
        <Route path="/visit/:visitId" element={<VisitDetailsScreen />} />
        <Route path="*" element={<NotFound404 />} />
      </Routes>
    </MainScreen>
  );
}
export default MainScreenNavigator;
